export enum IconPositions {
    Top = "-top",
    Left = "left",
    InnerLeft = "-innerLeft",
}
